<script>
import alertDescriptions from '../../model/v1/slotAlerts';
import ConsecutiveShiftsLimitIcon from '../icons/ConsecutiveShiftsLimitIcon.vue';
import InsufficientVacationIcon from '../icons/InsufficientVacationIcon.vue';
import MonthlyShiftLimitIcon from '../icons/MonthlyShiftLimitIcon.vue';
import NGStaffPairingIcon from '../icons/NGStaffPairingIcon.vue';
import PaperPlaneIcon from '../icons/PaperPlaneIcon.vue';
import UnassignedStaffIcon from '../icons/UnassignedStaffIcon.vue';

export default {
  props: {
    numReadComments: Number,
    numUnreadComments: Number,
    isClone: Boolean,
    shouldShowAlert: {
        type: Boolean,
        default: false,
    },
    alertIndex: {
        type: Number,
        default: 0,
    },
    askStatus: {
        type: Number,
        default: 0,
    },
    tooltipBottom: Boolean,
  },
  computed: {
    slotTopRightStyle() {
        return {
            'right': this.tooltipBottom ? '-2px' : '',
        }
    },
    displayUnreadCommentsCount() {
        return this.numUnreadComments > 9 ? '9+' : this.numUnreadComments;
    },
    displayReadCommentsCount() {
        return this.numReadComments > 9 ? '9+' : this.numReadComments;
    },
    displayReadCommentBadge() {
        return this.numReadComments && !this.isClone;
    },
    isAsked() {
        return this.askStatus > 0;
    },
    askedBadgeClass() {
        return {
            'asked-badge-accepted': this.askStatus === 2,
            'asked-badge-rejected': this.askStatus === 3,
        }
    },
    askedSlotTooltipText() {
        return this.askStatus === 3 ? '要請が承認されませんでした' : '要請';
    },
    alertDescription() {
        return this.alertIndex ? alertDescriptions[this.alertIndex] : "";
    },
  },
  components: {
    PaperPlaneIcon,
    UnassignedStaffIcon,
    ConsecutiveShiftsLimitIcon,
    MonthlyShiftLimitIcon,
    InsufficientVacationIcon,
    NGStaffPairingIcon,
  }
};
</script>

<template>
    <!-- Top Right Slot Badges -->
    <div class="slot-top-right" :style="slotTopRightStyle">
        <span v-if="numUnreadComments" class="circle-container comment-number-badge">{{ displayUnreadCommentsCount }}</span>
        <span v-else-if="displayReadCommentBadge" class="circle-container comment-number-badge comment-read-badge">{{ displayReadCommentsCount }}</span>

        <span v-if="isAsked" class="tooltip tooltip-left text-warning circle-container asked-badge" :class="askedBadgeClass" :data-tooltip="askedSlotTooltipText">
            <PaperPlaneIcon class="text-light"/>
        </span> 

        <span v-if="shouldShowAlert" class="tooltip tooltip-left circle-container alert-badge" :data-tooltip="alertDescription">
            <UnassignedStaffIcon v-if="alertIndex === 1"/>
            <ConsecutiveShiftsLimitIcon v-else-if="alertIndex === 2"/>
            <MonthlyShiftLimitIcon v-else-if="alertIndex === 3"/>
            <InsufficientVacationIcon v-else-if="alertIndex === 4"/>
            <NGStaffPairingIcon v-else-if="alertIndex === 5"/>
            <i v-else-if="alertIndex === 6" class="zmdi zmdi-close zmdi-hc-lg"></i>
            <div v-else>!</div>
        </span>
        <span class="overtime-slot-badge">
          <svg width="16" height="16" viewBox="-1 -1 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="7" cy="7" r="7.5" stroke="white" stroke-width="1"/>
            <path d="M7 0C8.85652 0 10.637 0.737498 11.9497 2.05025C13.2625 3.36301 14 5.14348 14 7C14 8.85652 13.2625 10.637 11.9497 11.9497C10.637 13.2625 8.85652 14 7 14C5.14348 14 3.36301 13.2625 2.05025 11.9497C0.737498 10.637 0 8.85652 0 7C0 5.14348 0.737498 3.36301 2.05025 2.05025C3.36301 0.737498 5.14348 0 7 0Z" fill="white"/>
            <path d="M7 0C8.85652 0 10.637 0.737498 11.9497 2.05025C13.2625 3.36301 14 5.14348 14 7C14 8.85652 13.2625 10.637 11.9497 11.9497C10.637 13.2625 8.85652 14 7 14C5.14348 14 3.36301 13.2625 2.05025 11.9497C0.737498 10.637 0 8.85652 0 7C0 5.14348 0.737498 3.36301 2.05025 2.05025C3.36301 0.737498 5.14348 0 7 0ZM6.34375 3.28125V7C6.34375 7.21875 6.45312 7.42383 6.63633 7.54688L9.26133 9.29688C9.56211 9.49922 9.96953 9.41719 10.1719 9.11367C10.3742 8.81016 10.2922 8.40547 9.98867 8.20312L7.65625 6.65V3.28125C7.65625 2.91758 7.36367 2.625 7 2.625C6.63633 2.625 6.34375 2.91758 6.34375 3.28125Z" fill="#FA7A7A"/>
          </svg>
        </span>
    </div>
</template>

<style scoped>
.comment-read-badge {
  background-color: #B1BABE;
}

.overtime-slot-badge {
  display: none;
  line-height: 0;
}
</style>

<style>
.overtime-active .has-overtime .overtime-slot-badge {
  display: block;
}
</style>
